import React from 'react'

import Price from '../sections/price'

export default function PriceFilters () {
  return (
    <div className='all-filters-content'>
      <Price />
    </div>
  )
}
